import React from "react";
import "./styles/AdListSkeleton.css";
import "./styles/WantedSearchCarousel.css";
import "./styles/ReelsCarousel.css";
import "./styles/HomeFeedSkeleton.css";
import AdListSkeleton from "./AdListSkeleton";

function Shimmer({ className }) {
  return <div className={`home-skeleton-shimmer ${className}`} aria-hidden="true" />;
}

function WantedSearchSkeletonCard() {
  return (
    <article className="wanted-search-skeleton-card">
      <div className="wanted-search-skeleton-card__user">
        <Shimmer className="wanted-search-skeleton-card__avatar" />
        <div className="wanted-search-skeleton-card__identity">
          <Shimmer className="home-skeleton-line home-skeleton-line--md" />
          <Shimmer className="home-skeleton-line home-skeleton-line--sm" />
          <Shimmer className="home-skeleton-line home-skeleton-line--xs" />
        </div>
      </div>
      <Shimmer className="home-skeleton-line home-skeleton-line--label" />
      <Shimmer className="home-skeleton-line home-skeleton-line--text" />
      <Shimmer className="home-skeleton-line home-skeleton-line--btn" />
      <Shimmer className="home-skeleton-line home-skeleton-line--count" />
    </article>
  );
}

export function WantedSearchSkeleton({ count = 3 }) {
  return (
    <section
      className="wanted-search-section wanted-search-section--skeleton"
      aria-busy="true"
      aria-label="Loading wanted searches"
    >
      <header className="wanted-search-section__header">
        <Shimmer className="home-skeleton-line home-skeleton-line--title" />
        <Shimmer className="home-skeleton-line home-skeleton-line--subtitle" />
      </header>
      <div className="wanted-search-carousel">
        {Array.from({ length: count }, (_, index) => (
          <WantedSearchSkeletonCard key={index} />
        ))}
      </div>
    </section>
  );
}

function ReelSkeletonCard() {
  return (
    <article className="reels-skeleton-card">
      <Shimmer className="reels-skeleton-card__thumb" />
      <div className="reels-skeleton-card__body">
        <Shimmer className="home-skeleton-line home-skeleton-line--reel-title" />
        <div className="reels-skeleton-card__user">
          <Shimmer className="reels-skeleton-card__avatar" />
          <div className="reels-skeleton-card__identity">
            <Shimmer className="home-skeleton-line home-skeleton-line--xs" />
            <Shimmer className="home-skeleton-line home-skeleton-line--xs" />
          </div>
        </div>
      </div>
    </article>
  );
}

export function ReelsSkeleton({ count = 5 }) {
  return (
    <section
      className="reels-section reels-section--skeleton"
      aria-busy="true"
      aria-label="Loading reels"
    >
      <header className="reels-section__header">
        <Shimmer className="home-skeleton-line home-skeleton-line--title" />
        <Shimmer className="home-skeleton-line home-skeleton-line--subtitle" />
      </header>
      <div className="reels-carousel">
        {Array.from({ length: count }, (_, index) => (
          <ReelSkeletonCard key={index} />
        ))}
      </div>
    </section>
  );
}

function HomeFeedSkeleton({ adCount = 8 }) {
  return (
    <React.Fragment>
      <WantedSearchSkeleton />
      <ReelsSkeleton />
      <AdListSkeleton count={adCount} />
    </React.Fragment>
  );
}

export default HomeFeedSkeleton;
